import { apiHandlerWithError } from 'api/apiHandler';

export default async function getCalendarItemsList(projectId) {
  let route = 'calendar-items';
  if (projectId !== null) {
    route += `?project_id=${projectId}`;
  }
  return await apiHandlerWithError(route);
}
